// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1X8MN","info":"PatientInfo_info__sHYgp"};